import { useBusinessDevelopmentActions, useBusinessDevelopmentStore } from 'stores/businessDevelopmentStore';

import createInsightsDashboardContainer from '../shared/createInsightsDashboardContainer';

import BusinessDevelopmentPage from './BusinessDevelopmentPage';

const { Context, useDashboardContext, Container } = createInsightsDashboardContainer({
  preferenceKey: 'businessDevelopmentProviderType',
  useSelectedGroupType: () => useBusinessDevelopmentStore((state) => state.selectedGroupType),
  useActions: useBusinessDevelopmentActions,
  Page: BusinessDevelopmentPage,
});

export const BusinessDevelopmentContext = Context;
export const useBusinessDevelopmentContext = useDashboardContext;
export default Container;
